import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import './CostFix.css'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import WordMonthDate from 'Components/DateChanged/WordMonthDate/WordMonthDate';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import FilterCostFix from '../FilterCostFix/FilterCostFix';

const CostFix = ({
    itemCostIdSelected
}) => {
    const [idCostFix, setIdCostFix] = useState(null);
    const [quantityItem, setQuantityItem] = useState(null);
    const [valueItem, setValueItem] = useState(null);
    const [dsItemId, setDsItemId] = useState(null);
    const [isRealValue, setIsRealValue] = useState(null);
    const [dsObservation, setDsObservation] = useState(null);
    const [username, setUsername] = useState(null);
    const [updateDate, setUpdateDate] = useState(null);
    const [isChangeCostDay, setIsChangeCostDay] = useState(null);
    const [effectiveStartDate, setEffectiveStartDate] = useState(null);
    const [effectiveFinishDate, setEffectiveFinishDate] = useState(null);
    const [dtFinish, setDtFinish] = useState(null)
    const [dtStart, setDtStart] = useState(null)

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);

    const [costFixListDetail, setCostFixListDetail] = useState(null);
    const [recordsCostFix, setRecordsCostFix] = useState(null);
    const [costFixIdSelected, setCostFixIdSelected] = useState([]);
    const [showFilterItemCost, setShowFilterItemCost] = useState(false);
    const [dtStartFilter, setDtStartFilter] = useState(null);
    const [dtFinishFilter, setDtFinishFilter] = useState(null);
    const [reloadCostFix, setReloadCostFix] = useState(null);

    const readOnlyAttributes = !(inserting || updating);
    const [identifierExternalProduction, setIdentifierExternalProduction] = useState(false)

    const [loadingCostFixPanel, setLoadingCostFixPanel] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            let identifier
            try {
                identifier = await ExecuteAxios.api('get', `/general-settings/selected-external-item-identifier/`)
                setIdentifierExternalProduction(identifier)
            } catch {
                setIdentifierExternalProduction(null)
            }
        }
        fetchData();
    }, [])

    const messageIsChangeCostDay = () => {
        if (inserting) {
            return ('Inserir orçamento detalhado')
        } else {
            return ('Atualizar orçamento detalhado')
        }
    }

    useEffect(() => {
        setCostFixIdSelected([])
    }, [dtStartFilter, dtFinishFilter])

    useEffect(() => {
        if (itemCostIdSelected.length === 0) {
            setUpdating(false)
            setInserting(false)
        }

        getCostFixRecords()
        setAttributesPanel();
    }, [inserting, updating, itemCostIdSelected, dtStartFilter, dtFinishFilter])

    useEffect(() => {
        if (reloadCostFix) {
            setReloadCostFix(false)
            getCostFixRecords()

        }
    }, [reloadCostFix])

    const setAttributesPanel = async () => {
        if (!itemCostIdSelected[0]) {
            return;
        }

        const dsItem = await ExecuteAxios.api('get', '/item-cost/desc-item-cost-by-id/', {
            params: {
                id: itemCostIdSelected[0],
            }
        })

        setDsItemId(dsItem)
    }

    const attributeList = [
        { name: "id", value: idCostFix, setter: setIdCostFix, allowsMultipleRecordsSelected: true },
        { name: "quantityItem", value: quantityItem, setter: setQuantityItem },
        { name: "valueItem", value: valueItem, setter: setValueItem },
        { name: "dsItem", value: dsItemId, setter: null, readOnly: true },
        {
            name: "isRealValue",
            value: isRealValue,
            setter: setIsRealValue,
            resetValue: 'S',
            checks: [
                { field: 'isRealValue', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "dtStart", value: dtStart, setter: setDtStart, isVisible: isChangeCostDay === 'S', isMandatory: (isChangeCostDay === 'S' ? 'S' : 'N') },
        { name: "dtFinish", value: dtFinish, setter: setDtFinish, isVisible: isChangeCostDay === 'S', isMandatory: (isChangeCostDay === 'S' ? 'S' : 'N') },
        { name: "observation", value: dsObservation, setter: setDsObservation },
        { name: "username", value: username, setter: setUsername, readOnly: 'S' },
        { name: "dtUpdate", value: updateDate, setter: setUpdateDate, readOnly: 'S' },
        {
            name: "isAddAnnualBudget",
            value: isChangeCostDay,
            setter: setIsChangeCostDay,
            customMessage: messageIsChangeCostDay()
        },
        { name: "effectiveStartDate", value: effectiveStartDate, setter: setEffectiveStartDate },
        { name: "effectiveFinishDate", value: effectiveFinishDate, setter: setEffectiveFinishDate }
    ]

    useEffect(() => {
        if (isChangeCostDay !== 'S') {
            setDtStart(null)
            setDtFinish(null)
        }
    }, [isChangeCostDay]);

    useEffect(() => {
        setCostFixIdSelected([]);
    }, [itemCostIdSelected])

    const callToSetAttributesPanel = async (costFixIdSelected) => {
        const parameters = { id: costFixIdSelected }
        const costFix = await ExecuteAxios.api('get', `/cost-fix/get-cost-by-id/`, { params: parameters })
        setCostFixListDetail(costFix)
        if (costFix) {
            ApplyAttributes.applyAttributes(costFix, attributeList)
        }

        if (!costFixIdSelected || costFixIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    useEffect(() => {
        if (costFixIdSelected && costFixIdSelected.length === 1) {
            callToSetAttributesPanel(costFixIdSelected[0])
        } else {
            callToSetAttributesPanel(null)
        }
    }, [costFixIdSelected, updating === true]);

    const userControlPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%'
    };

    async function onUpdateInsert(value) {
        setInserting(value)
    }

    async function getCostFixRecords() {
        if (itemCostIdSelected || itemCostIdSelected.length === 1) {
            const parameters = {
                itemId: itemCostIdSelected[0],
                dtStart: dtStartFilter,
                dtFinish: dtFinishFilter,
            }
            const itemsCost = await ExecuteAxios.api('get', `/cost-fix/get-cost-fix-by-itemId-month/`, { params: parameters })
            setRecordsCostFix(itemsCost)
            RemoveIdsNotFound.remove(itemsCost, setCostFixIdSelected, costFixIdSelected)
        }
    }

    const costFixPanelListOrDetail = () => {
        if (!inserting && !updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setCostFixIdSelected}
                    idsSelected={costFixIdSelected}
                    data={recordsCostFix}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={costFixListDetail}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postCostFix() {
        try {
            setLoadingCostFixPanel(true)
            return await ExecuteAxios.api('post', `/cost-fix/`, {
                quantityItem: quantityItem,
                valueItem: valueItem,
                itemId: itemCostIdSelected[0],
                isRealValue: isRealValue ? isRealValue : 'N',
                observation: dsObservation,
                dtStart: dtStart,
                dtFinish: dtFinish,
                isAddAnnualBudget: isChangeCostDay,
                effectiveStartDate: effectiveStartDate,
                effectiveFinishDate: effectiveFinishDate

            });
        } finally {
            setLoadingCostFixPanel(false)
        }
    }

    async function putCostFix() {
        if (costFixIdSelected && costFixIdSelected.length === 1) {
            try {
                setLoadingCostFixPanel(true)
                return await ExecuteAxios.api('put', `/cost-fix/`, {
                    id: idCostFix,
                    quantityItem: quantityItem,
                    valueItem: valueItem,
                    itemId: itemCostIdSelected[0],
                    isRealValue: isRealValue ? isRealValue : 'N',
                    observation: dsObservation,
                    dtStart: dtStart,
                    dtFinish: dtFinish,
                    isAddAnnualBudget: isChangeCostDay,
                    effectiveStartDate: effectiveStartDate,
                    effectiveFinishDate: effectiveFinishDate
                });
            } finally {
                setLoadingCostFixPanel(false)
            }
        }
    }

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%'
    }

    function getDateButtons() {
        if (!inserting && !updating) {
            return (
                <Panel style={styleButtonsMonth}>

                </Panel>
            )
        } else return null
    }

    const dateButtons = getDateButtons()

    function canNewRecord() {
        if (!itemCostIdSelected) {
            return false
        }

        if (itemCostIdSelected && itemCostIdSelected.length != 1) {
            return false
        }

        if ([1, 2, 3, 4, 5, 6, 7, identifierExternalProduction].includes(itemCostIdSelected[0])) {
            return false;
        }
        return true
    }

    function canEdit() {
        if (!itemCostIdSelected) {
            return false
        }
        if (!costFixIdSelected || costFixIdSelected.length === 0) {
            return false
        }
        if (itemCostIdSelected && itemCostIdSelected.length != 1) {
            return false
        }
        if ([1, 2, 3, 4, 5, 6, 7, identifierExternalProduction].includes(itemCostIdSelected[0])) {
            return false;
        }
        return true
    }

    async function deleteCostFixIdsSelecteds(recordsSelected) {
        try {
            setLoadingCostFixPanel(true)
            const parameters = {
                idsList: recordsSelected.join(",")
            };
            const response = await ExecuteAxios.api('delete', `/cost-fix/`, { params: parameters });
            if (response) {

                setReloadCostFix(true)
                setCostFixIdSelected([]);
                ResetVariables.resetVariables(attributeList)
            }
            return response
        } finally {
            setLoadingCostFixPanel(false)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingCostFixPanel}>
            <FilterCostFix
                showFilterItemCost={showFilterItemCost}
                dtStartFilter={dtStartFilter}
                dtFinishFilter={dtFinishFilter}
                onUpdateShowFilterItemCost={setShowFilterItemCost}
                onUpdateDtStartFilter={setDtStartFilter}
                onUpdateDtFinishFilter={setDtFinishFilter}
            />
            <Panel
                titlePage='Orçamentos itens pré-cadastrados'
                style={userControlPanelStyle}
                setUpdating={setUpdating}
                setInserting={onUpdateInsert}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canDelete={costFixIdSelected && costFixIdSelected.length > 0}
                enableDelete={costFixIdSelected && costFixIdSelected.length > 0}
                deleteFunction={deleteCostFixIdsSelecteds}
                canEdit={canEdit()}
                putFunction={putCostFix}
                enableNewRecord={true}
                canNewRecord={canNewRecord()}
                postFunction={postCostFix}
                canViewCRUD={true}
                recordsSelected={costFixIdSelected}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={costFixListDetail}
                attributeList={attributeList}
                componentLeftButtons={dateButtons}
                filterAction={(inserting || updating) ? null : setShowFilterItemCost}
            >
                {costFixPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );
};

export default CostFix;


